import { Box, BoxProps, ColorOptions, Spacer, Text, TextProps } from '@jfs/ui-new'
import { useNavigation, useRoute } from '@react-navigation/core'
import React, { useCallback } from 'react'
import { MerchantTheme } from '../../../../data/models/Config'
import { useStores } from '../../../../data/store'
import { convertHexToRGBA } from '../../../../utils'
import { pages } from '../../../../utils/constants'
import { ProgressIndicator } from '../../comps/ProgressIndicator'
import { EmiList } from './EmiList'
import { SelectedEmiPlanInfo } from './SelectedEmiPlanInfo'

export const SelectEmiPlans = () => {
  const { theme, amountPayable } = useStores((root) => ({
    theme: root.config.merchantTheme,
    amountPayable: root.jioPayFinanceHub.amountPayable,
  }))
  const emiPlansData: any = useRoute().params

  const style = stylesFunc(theme as any)

  const navigation = useNavigation()

  const onPlanSelected = useCallback(
    (item: never) => {
      navigation.navigate(
        pages.proceedToPayment as never,
        {
          selectedEMIData: item,
          emiList: emiPlansData,
          metaData: emiPlansData.metaData,
        } as never,
      )
    },
    [emiPlansData, navigation],
  )

  return (
    <Box {...style.container} backgroundColor={theme?.bodyBgColor as ColorOptions}>
      <Box ph={32} pb={32}>
        <ProgressIndicator data={['Eligibility', 'EMI Plan', 'Payment']} currentStep={2} />
      </Box>
      <SelectedEmiPlanInfo amountPayable={amountPayable} bankName={emiPlansData?.bankName} theme={theme} />
      <Spacer size={18} />
      <Box borderTopWidth={6} borderColor={convertHexToRGBA(theme.bodyTextColor, 10) as any} flex={1} pv={18}>
        <Box ph={18}>
          <Text {...style.header}>Choose an EMI Plans</Text>
        </Box>
        <EmiList
          theme={theme}
          emiPlansData={emiPlansData}
          amountPayable={amountPayable}
          onPlanSelected={onPlanSelected}
        />
      </Box>
    </Box>
  )
}

const stylesFunc = (theme: typeof MerchantTheme.properties) => ({
  container: {
    pv: 24,
    flexDirection: 'column',
    height: '100%',
    flex: 1,
  } as BoxProps,
  header: {
    fontSize: 14,
    color: theme?.bodyTextColor as any,
    fontFamily: 'jiotype-Medium',
  } as TextProps,
})
